import { ReactElement, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import {
  Typography,
  Box,
  Button,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'next-i18next';
import NextLink from 'src/components/atoms/link';
import { ROUTES } from 'src/helpers/constants';
import { CPDEnrollmentStatusEnum, CPDRegulatorTypeEnum } from 'src/interfaces';
import { ICPDBundleEnrollment } from 'src/interfaces/bundle';

import { useCssClasses } from './style';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

type Props = {
  dialog: { opened: boolean; open: () => void; close: () => void; render: (children: ReactElement) => JSX.Element };
  citizenId: string;
  regulator?: CPDRegulatorTypeEnum;
  cpdEnrollment?: ICPDBundleEnrollment;
};

const CannotEnrollmentToCourseModal = ({
  dialog,
  citizenId,
  regulator = CPDRegulatorTypeEnum.ALL,
  cpdEnrollment,
}: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const classes = useCssClasses();

  return (
    <>
      <DialogTitle classes={{ root: classes.root }}>
        <Box sx={{ position: 'absolute', top: 8, right: 8 }}>
          <IconButton onClick={dialog.close} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', rowGap: 1 }}>
          <FontAwesomeIcon
            style={{ fontSize: '50px' }}
            color={theme.palette.errorV2.main}
            icon="fa-light fa-circle-xmark"
          />
          <Typography sx={{ whiteSpace: 'nowrap' }} color="primary.main" variant="h3">
            {t('cpd_course.you_cannot_enroll_to_course')}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {cpdEnrollment?.notEnrollToCourse &&
            cpdEnrollment?.status !== CPDEnrollmentStatusEnum.Available &&
            cpdEnrollment?.status !== CPDEnrollmentStatusEnum.LicenseSuspended && (
            <Typography className={classes.dialogContentText} variant="body2_deprecated">
              <span>
                {t('cpd_course.how_not_enroll', {
                  course: cpdEnrollment.notEnrollToCourse[cpdEnrollment.status][0].courseName,
                  reason: t(`cpd_course.${cpdEnrollment.status}`),
                })}
              </span>
            </Typography>
          )}

          <Typography className={classes.dialogContentText} variant="body2_deprecated">
            <span>{t('cpd_course.please_select_another_course')}</span>
            <span>{t('cpd_course.or_found_any_problem')}</span>
            <span>{t('cpd_course.contact_skilllane_officer')}</span>
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <NextLink href={ROUTES.CPD_SEARCH_RESULT({ citizenId, regulator })}>
          <Button variant="contained" color="primary">
            {t('cpd_course.view_suitable_course')}
          </Button>
        </NextLink>
      </DialogActions>
    </>
  );
};

export default CannotEnrollmentToCourseModal;
